import React, { useState, useEffect } from "react";
import "./rider.css";
// import { riderZoneAssign, getRiderDetail } from "../../services/riders.service";
import { swalNotification } from "../../components/alret/notificztion";
import {Table, Menu, Dropdown, Space, Button, Image, Typography, Result, Input, Select, Modal, Badge, Tooltip,} from "antd";
import Pageloader from "../../components/loader";
import BatchModal from "../../components/modal/riders/batchModal";
import BreakModal from "../../components/modal/riders/breakModal";
import ZoneModal from "../../components/modal/riders/zoneModal";
import RiderEditModal from "../../components/modal/riders/RiderEditModal";
import ModalAssignRiderZones from "../../components/modal/riders/modalAssignRiderZones";
import { MoreOutlined, ReloadOutlined, EnvironmentOutlined, CalendarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { userhasPermissionHelper, validationErrors } from "../../utils/Helpers";
import moment from "moment";
import altimg from "../../assets/images/placeholder/placeimg50.png";
import { getRidingTracking } from "../../services/orderManagement.service";
import * as riderActions from "../../redux/actions/rider.actions";
import * as batchActions from "../../redux/actions/batch.action";
import * as zoneActions from "../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";

const { Text, Title } = Typography;
const { Search } = Input;
const { Option } = Select;

const Rider = (props) => {
  const pagename = "Riders";
  const [postData, setPostData] = useState(null);
  // const [totalRiders, setTotalRiders] = useState(null);
  const [activeRiders, setActiveRiders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);

  const [postDatabatch, setPostDatabatch] = useState(null);
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneSelect, setPostDataZoneSelect] = useState(null);
  const [locationUpdatedAt, setlocationUpdatedAt] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userId, setUserId] = useState(props.user.id);
  const [token, setToken] = useState(props.user.token);
  const [totalPages, setTotalPages] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const navigate = useNavigate();

  useEffect(() => {
    if (postData) {
      setErrMsg(null);
    }
    totalActiveRiders();
  }, [postData]);
  useEffect(() => {
    if (token != "") {
      riderList();
      totalActiveRiders();
      setUserId(props.user.id);
      setToken(props.user.token);
    }
  }, [props.user]);
  const characterLength = (value) => {
    return value.length > 10 ? `${value.substring(0, 10)}...` : value;
  };

  // after getRidersFiltersPaginationAction call
  useEffect(() => {
    setlocationUpdatedAt([]);
    setPostData(props.riderData);
    // setTotalRiders(props.riderData.length);
  }, [props.riderData]);
  useEffect(() => {
    setlocationUpdatedAt([]);
    setTotalPages(props.riderPagination.totalCount);
    setCurrentPageSize(props.riderPagination.limit);
    setCurrentPage(props.riderPagination.currentPage);
  }, [props.riderPagination]);
  useEffect(() => {
    setlocationUpdatedAt([]);
    setPostDatabatch(props.batchData);
  }, [props.batchData]);
  useEffect(() => {
    setlocationUpdatedAt([]);
    setPostDataZone(props.zoneData);
  }, [props.zoneData]);

  const riderList = async (show_loder = true) => {
    try {
      const data = {
        page: currentPage,
        limit: currentPageSize,
      };
      if (show_loder) setLoading(true);
      // postListsrefresh(); //commented to reduce api calls for now its use is for active status
      await props.riderActions.getRidersFiltersPaginationAction(data);
      await props.batchActions.getBatchListAction();
      await props.zoneActions.getZoneListAction();
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
      // setRefreshDisabled(false);
    }
  };
  const postListsrefresh = async () => {
    try {
      await props.riderActions.getRiderListAction();
      await props.batchActions.getBatchListAction();
      await props.zoneActions.getZoneListAction();
    } catch (e) {
      // throw e;
      validationErrors(e);
      // setErrMsg("Something went wrong");
    } finally {
      setLoading(false);
      // setRefreshDisabled(false);
    }
  };
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item, i) => {
        zoneData.push(<Option key={item.id}>{item.zoneName}</Option>);
      });
      setPostDataZoneSelect(zoneData);
    }
  }, [props.zoneData]);

  const totalActiveRiders = async () => {
    let activeStatus = [];
    (await postData) &&
      postData.map((v, i) => {
        if (v.status !== undefined) {
          if (v.status === "available" || v.status === "approved") {
            activeStatus.push(v.status);
          }
        }
        setActiveRiders(activeStatus.length);
      });
  };

  const [riderEditOpenModal, setRiderEditOpenModal] = useState(false);
  const [assignBatchModal, setAssignBatchModal] = useState(false);
  const [assignBreakModal, setAssignBreakModal] = useState(false);
  const [assignZoneModal, setAssignZoneModal] = useState(false);
  const [RiderId, setRiderId] = useState(null);
  const [RiderImage, setRiderImage] = useState(null);
  const [RiderDisplayId, setRiderDisplayId] = useState(null);
  const [RiderTookanId, setRiderTookanId] = useState(null);
  const [RiderName, setRiderName] = useState("");
  const [riderBatchId, setRiderBatchId] = useState("");
  const [riderZoneId, setRiderZoneId] = useState("");
  // const [assigbriderBatchChange, setassigbriderBatchChange] = useState("");
  const [assigbriderZoneChange, setassigbriderZoneChange] = useState("");
  const [riderData, setRiderData] = useState(null);

  // const [loadings, setLoadings] = useState([]);

  const [MBtnLoading, setMBtnLoading] = useState(false);
  const importTookanData = async () => {
    try {
      setMBtnLoading(true);
      await props.riderActions.refreshTookanDataAction().then((res) => {
        if (res) {
          if (res["status"]) {
            swalNotification("Rider Data Import", res["message"], "success");
            postListsrefresh();
          }
        }
      });
    } catch {
      setErrMsg("Something went wrong");
    } finally {
      setMBtnLoading(false);
    }
  };

  const batchModal = (id, name, batch) => {
    setRiderId(id);
    setRiderName(name);
    setRiderBatchId(batch);
    setAssignBatchModal(true);
  };

  const breakModal = (id, name, image, rider_display_id, rider_tookan_id) => {
    // setRiderId(null);
    const RID = {
      riderId: id,
    };

    setRiderId(RID);
    setRiderName(name);
    setRiderImage(image);
    setRiderDisplayId(rider_display_id);
    setRiderTookanId(rider_tookan_id);
    setAssignBreakModal(true);
  };
  const handleSuspended = async (riderId, riderStatus) => {
    const data = {
      "riderId": riderId,
      "status": riderStatus
    }
    try {
      setLoading(true);
      if (data)
        await props.riderActions.RiderSuspendStatusAction(data);
    } catch (e) {} finally {
      setLoading(false);
      postListsrefresh()
    }
  }

  const handleSus = async (riderId, riderStatus) => {
    const data = {
      "riderId": riderId,
      "status": riderStatus
    }
    try {
      setLoading(true);
      if (data)
        await props.riderActions.RiderSuspendStatusAction(data);
    } catch (e) {} finally {
      setLoading(false);
      postListsrefresh()
    }
  }



  useEffect(() => {
    setRiderData(props.riderDetailData);
  }, [props.riderDetailData]);

  const RiderEditModalOpen = async (riderId) => {
    // setRiderData(null);
    try {
      await props.riderActions.getRiderDetailAction(riderId); //.then((res) => {
      setRiderId(riderId);
      setRiderEditOpenModal(true);
    } catch (error) {
      setRiderData([]);
      validationErrors(error);
    }
  };

  const [showBatchSubmitLoder, setShowBatchSubmitLoder] = useState(false);
  const BatchModalHandleOk = async () => {
    const riderBatch = { riderId: RiderId, batchId: riderBatchId };
    setShowBatchSubmitLoder(true);
    try {
      await props.riderActions.getRiderDetailAction(RiderId).then((res) => {
        // console.log(res);
        if (res.status) {
          if (res.data.status === "pending") {
            swalNotification(
              "Rider Verification",
              "Rider not approved yet.",
              "error"
            );
            setAssignBatchModal(false);
          } else {
            props.riderActions
              .riderBatchAssignAction(riderBatch)
              .then((res) => {
                if (res) {
                  postListsrefresh();
                  swalNotification(
                    "Rider Batch Assigned",
                    "Rider batch assigned successfully",
                    "success"
                  );
                  setAssignBatchModal(false);
                }
              });
          }
        }
      });
    } catch (error) {
      validationErrors(error);
    } finally {
      setShowBatchSubmitLoder(false);
    }
  };

  const handleZoneOk = async () => {
    // console.log(RiderId, RiderName, assigbriderZoneChange);
    const riderZone = { riderId: RiderId, zoneId: assigbriderZoneChange };
    // console.log("rider zone update values", riderZone);
    // return null;
    const headers = {
      "Content-Type": "application/json",
      UserId: userId,
    };

    try {
      await props.riderActions.getRiderDetailAction(RiderId).then((res) => {
        if (res.status) {
          if (res.data.status === "pending") {
            swalNotification(
              "Rider Verification",
              "Rider not approved yet.",
              "error"
            );
            setAssignBatchModal(false);
          } else {
            props.riderActions.riderZoneAssign(RiderId).then((res) => {});
            riderList(false);
            swalNotification(
              "Rider Zone Assigned",
              "Rider Zone assigned successfully",
              "success"
            );
            setAssignZoneModal(false);
          }
        }
      });
    } catch (error) {
      validationErrors(error);
    }
  };

  const handleCancel = () => {
    setAssignBatchModal(false);
  };

  const handleZoneModalCancel = () => {
    setAssignZoneModal(false);
  };

  const handleBreakModalCancel = () => {
    setAssignBreakModal(false);
  };

  const riderBatchChange = (value) => {
    // console.log(value);
    // setassigbriderBatchChange(value);
    setRiderBatchId(value);
  };

  const riderZoneChange = (value) => {
    // console.log("rider zone chnage value", value);
    setRiderZoneId(value);
    setassigbriderZoneChange(value);
  };

  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [tookanRiderId, setTookanRiderId] = useState("");
  const [displayId, setDisplayId] = useState("");
  const [status, setStatus] = useState("");
  const [filterZone, setFilterZone] = useState("");

  const handleChangeZone = (value) => {
    setFilterZone(value);
    globalSearch(
      search,
      status,
      "",
      displayId,
      value,
      currentPage,
      currentPageSize
    );
  };

  const setSearchValue = (value) => {
    setSearch(value);
    setTookanRiderId("");
    globalSearch(value, status, "", "", filterZone, currentPage, currentPageSize);
  };

  const setDisplayIdValue = (value) => {
    setDisplayId(value);
    setSearch("");
    globalSearch("", status, "", value, filterZone, currentPage, currentPageSize);
  };

  const setTookanRiderIdValue = (value) => {
    setTookanRiderId(value);
    setSearch("");
    globalSearch("", status, value, "", filterZone, currentPage, currentPageSize);
  };

  const setFiltervalue = (value) => {
    setFilter(value);
    if (value == "all") {
      setSearch("");
      setStatus("");
      setTookanRiderId("");
      setDisplayId("");
      globalSearch("", "", "", "", filterZone, currentPage, currentPageSize);
    }
  };

  const setStatusValue = (value) => {
    setStatus(value);
    var fleet_id = filter == "fleet_id" ? tookanRiderId : "";
    var display_id = filter == "display_id" ? displayId : "";
    globalSearch(
      search,
      value,
      fleet_id,
      displayId,
      filterZone,
      currentPage,
      currentPageSize
    );
  };

  const searchkeys = [
    "display_id",
    "fleet_id",
    "fullName",
    "phoneNumber",
    "status",
  ];

  const handleClick = async (id, type, cnic) => {
    if (type === "approved") {
      const rider_id = { riderId: id };
      try {
        await props.riderActions.riderApproveAction(rider_id).then((res) => {
          // console.log(resp);
          riderList(false);
          swalNotification(
            "Rider Approved",
            "Rider status approved successfully",
            "success"
          );
        });
      } catch (error) {
        validationErrors(error);
      }
    }
    if (type === "blocked") {
      const rider_id = { riderId: id };
      const headers = {
        "Content-Type": "application/json",
        UserId: userId,
      };
      try {
        await props.riderActions.riderBlockAction(rider_id).then((res) => {
          riderList(false);
          swalNotification(
            "Rider Blocked",
            "Rider status blocked successfully",
            "success"
          );
        });
      } catch (error) {
        validationErrors(error);
      }
    }
    if (type === "sync_rms") {
      const rider_id = { riderId: id };
      try {
        await props.riderActions.RiderSyncRmsAction(rider_id).then((res) => {
          riderList(false);
          swalNotification(
            "Rider Sync",
            "Rider sync to RMS successfully",
            "success"
          );
        });
      } catch (error) {
        validationErrors(error);
      }
    }
  };

  const actions = (
    riderId,
    riderStatus,
    riderCnic,
    riderName,
    riderBatch,
    riderZone,
    riderApproved,
    riderImage,
    riderDisplayId,
    riderTookanId
  ) => {
    const handlePressOk = async (riderId, status, riderCnic) => {
      setIsDisabled(true);
      await handleClick(riderId, status, riderCnic);
    };
    return (
      <Menu
        items={[
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_RIDERS) &&
          (riderStatus==='suspended' ? "":
          riderStatus === "blocked" && riderApproved === true ? "" : {
            key: "1",
            label: riderStatus === "blocked" && riderApproved === true ? ("") : (
              <a onClick={() => RiderEditModalOpen(riderId)}>Edit</a>
            )
          }),
          // {
          //   key: "2",
          //   label: <a href={`/rider/${riderId}`}>View {pagename}</a>,
          // },
          // {
          //   key: "2",
          //   label: <a onClick={() => AssignBatchModal()}>Assign Batch</a>,
          // },
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_ASSIGN_BATCH) &&
          (riderStatus==='suspended' ? "":
          {
            key: "2",
            label: (<a onClick={() => batchModal(riderId, riderName, riderBatch)}>Assign Batch</a>),
          }),
          // {
          //   key: "3",
          //   label: (
          //     <a onClick={() => zoneModal(riderId, riderName, riderZone)}>
          //       Assign Zone
          //     </a>
          //   ),
          // },
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_UNBLOCK) &&
          (riderStatus==='suspended' ? "":
          (riderStatus === "blocked") && (riderApproved === true || riderApproved === false) ? {
            key: "4",
            label: (<div style={{ pointerEvents: riderStatus === "approved" ? "none" : "auto", }} >
              <a onClick={() => Modal.confirm({
                  content: "Are you sure you want to continue?",
                  centered: true,
                  maskClosable: true,
                  onOk: async () => await handlePressOk(riderId, "approved", riderCnic),
                })}
              >
                {
                  (riderStatus === "available") && riderApproved === true ? 
                  ""
                    :
                  ( riderStatus === "blocked" && riderApproved === true ? "UnBlock" : "" )
                }
              </a>
            </div>),
          }: ""),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_APPROVE) &&
          (riderStatus==='suspended' ? "":
          (riderStatus === "pending") && (riderApproved === true || riderApproved === false) ? {
            key: "5",
            label: (<div style={{ pointerEvents: riderStatus === "approved" ? "none" : "auto", }} >
              <a onClick={() => Modal.confirm({
                  content: "Are you sure you want to continue?",
                  centered: true,
                  maskClosable: true,
                  onOk: async () => await handlePressOk(riderId, "approved", riderCnic),
                })}
              >
                {
                  (riderStatus === "approved") && riderApproved === true ? 
                  ""
                    :
                  riderStatus === "pending" && riderApproved === false ? "Approved" : ""
                }
              </a>
            </div>),
          }: ""),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_BLOCK) &&
          (
            riderStatus==='suspended' ? "":
            (riderStatus === "available" || riderStatus === "approved") && riderApproved === true ? {
              key: "6",
              label: (<div style={{ pointerEvents: riderStatus === "blocked" ? "none" : "auto",}} >
                <a onClick={() => Modal.confirm({
                  content: "Are you sure you want to continue?",
                  centered: true,
                  maskClosable: true,
                  onOk: async () => await handlePressOk(riderId, "blocked", riderCnic),
                })} >
                  {(riderStatus === "available" || riderStatus === "approved") && riderApproved === true ? "Block" : ""}
                </a>
              </div>),
            }: ""
          ),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_BREAK) &&
          (riderStatus==='suspended' ? "":
           riderStatus === "blocked" && riderApproved === true ? "" : {
            key: "7",
            label: (<a onClick={() => breakModal(riderId, riderName, riderImage, riderDisplayId, riderTookanId)} >Break</a>),
          }),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPEND) &&
          (
            ( riderStatus !== "blocked" && riderStatus === "available" && (riderApproved === true || riderApproved !== false) ) ? {
            key: "8",
            label: (<div style={{pointerEvents: riderStatus === "approved" ? "none" : "auto", }}>
              <a onClick={() => Modal.confirm({
                content: riderStatus === "available" ? "Are you sure you want to Suspend Rider":"",
                centered: true,
                maskClosable: true,
                onOk: async () => await handleSuspended(riderId, riderStatus === "available" ? "suspended":""),
              })} >
                {riderStatus === "available" ? "Suspend":""}
              </a>
            </div>)}: ""
          ),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_ACTIVE) &&
          (
            ( riderStatus !== "blocked" && (riderStatus==="suspended" || riderStatus==='inactive') && (riderApproved === true || riderApproved !== false) ) ? {
            key: "9",
            label: (<div style={{pointerEvents: riderStatus === "approved" ? "none" : "auto", }}>
              <a onClick={() => Modal.confirm({
                content: (riderStatus === "suspended" || riderStatus === "inactive") ? "Are you sure you want to Activate Rider": "",
                centered: true,
                maskClosable: true,
                onOk: async () => await handleSuspended(riderId, (riderStatus==="suspended" || riderStatus==="inactive") ?"available":""),
              })} >
                {riderStatus==="suspended" || riderStatus==='inactive'?"Active":""}
              </a>
            </div>)}: ""
          ),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SYNC_TO_RMS) &&
          (riderApproved === false ? "":
          {
            key: "10",
            label: (<div style={{ pointerEvents: "auto" }} >
            <a onClick={() => Modal.confirm({
              content: "Are you sure you want to continue ?",
              centered: true,
              maskClosable: true,
              onOk: async () => await handlePressOk(riderId, "sync_rms", riderCnic),
            })} >
              Rider Sync to RMS
            </a>
          </div>),
          }),

          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPEND) &&
          (
            ( riderStatus !== "blocked" && riderStatus === "available" && (riderApproved === true || riderApproved !== false) ) ? {
            key: "13",
            label: (<div style={{pointerEvents: riderStatus === "approved" ? "none" : "auto", }}>
              <a onClick={() => Modal.confirm({
                content: riderStatus === "available" ? "Are you sure you want to Inactive Rider":"",
                centered: true,
                maskClosable: true,
                onOk: async () => await handleSuspended(riderId, riderStatus === "available" ? "inactive":""),
              })} >
                {riderStatus === "available" ? "Inactive":""}
              </a>
            </div>)}: ""
          ),

        ]}
      />
    );
  };

  const rloc = async (value)=>{
    try{
      const res = await getRidingTracking(value)
      if (res.data.code === 200 && res.data.data.length > 0){
          const resloc = res.data.data[0]
          return window.open(`https://maps.google.com/?q=${resloc.lat},${resloc.lon}`);
      } else {
        swalNotification("", "Rider location not found", "error")
      }
    }
    catch{}
    finally{}
  }

  const rlocDate = async (value)=>{
    try{
      const res = await getRidingTracking(value)
      const reslocDate = res.data.data[0];
      if (res.data.code === 200 && res.data.data.length > 0){
        setlocationUpdatedAt({
          ...locationUpdatedAt,
          [value]: moment(reslocDate.date).format("DD MMMM, yyyy, h:mm A")
        });
      } else {
        swalNotification("", "Rider location not found", "error")
      }
    }
    catch{}
    finally{}
  }

  const riderColumns = [
    {
      title: "Rider ID",
      dataIndex: "display_id",
      key: "display_id",
    },
    {
      title: "Tookan Rider ID",
      render: (fleet_id) => (fleet_id ? <Text>{fleet_id}</Text> : "--"),
      dataIndex: "fleet_id",
      key: "fleet_id",
    },
    {
      title: "Batch",
      render: (batch) => {return batch.id === null ? "--" : <Text>{batch.batchLevel}</Text>},
      dataIndex: "batch",
      key: "batch",
    },
    // {
    //   title: "Zone",
    //   render: (zone) =>
    //     zone._id !== null ? <Text>{zone.zoneName}</Text> : "--",
    //   dataIndex: "zone",
    // },
    {
      title: "Image",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (imgPath) => {return imgPath == "app/img/user.png" ? (<img alt="Profile Image" src={altimg} />) : imgPath != null ? (
       <Image alt="Profile Image" src={"data:image/jpeg;base64," + imgPath} />) : (<img alt="Profile Image" src={altimg} />)},
    },
    {
      title: "Full Name",
      render: (fullName) => fullName ? (<Tooltip title={fullName}><Text>{characterLength(fullName)}</Text></Tooltip>):(""),
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Email",
      render: (email) =>email ? (<Tooltip title={email}><Text>{characterLength(email)}</Text></Tooltip>):(""),
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Rider Loc",
      render: (value) => {
        return value ? (
          <>
            <a onClick={() => rloc(value)}>
              <Tooltip title={"Rider current location"}>
                <EnvironmentOutlined />
              </Tooltip>
            </a>
            {locationUpdatedAt[value] ? (
              <p>{locationUpdatedAt[value]}</p>
            ) : (
              <a onClick={() => rlocDate(value)} style={{ paddingLeft: "0.5rem" }}>
                <Tooltip title={"Location Updated At"}>
                  <CalendarOutlined />
                </Tooltip>
              </a>
            )}
          </>
        ) : (
          "-"
        );
      },
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Device Type",
      dataIndex: "deviceType",
      key: "deviceType",
    },
    {
      title: "Device Version",
      render: (deviceId) => deviceId ? <Text>{characterLength(deviceId)}</Text> : "",
      dataIndex: "deviceId",
      key: "deviceId",
    },
    {
      title: "Status",
      render: (record) => {return record.status ? (<Text
        type={[(record.status === "available" || record.status === "approved") && record.is_approved === true ? "success"
          : record.status === "blocked" && record.is_approved === true ? "danger"
          : record.status === "pending" && record.is_approved === false ? "warning"
          : record.status == "break" ? "success"
          : record.status == "inactive" ? "danger"
          : record.status=='suspended' ? 'secondary': "",
        ]}
      >
        {(record.status === "available" || record.status === "approved") && record.is_approved === true ? "Active"
          : record.status === "pending" && record.is_approved === false ? "Verification Pending"
          : record.status === "blocked" && record.is_approved === true ? "Blocked"
          : record.status == "break" ? "Active"
          : record.status == "inactive" ? "Inactive"
          : record.status=='suspended' ? 'Suspended': ""}
      </Text>) : ("")},
      // dataIndex: "status",
      // key: "status",
    },
    {
      title: "Work Status",
      render: (record) => {return record ? (<Text type={[record === "delivery-in-progress" ? "danger" : "success"]}>{record === "delivery-in-progress" ? "busy" : record}</Text>) : ("")},
      dataIndex: "work_status",
      key: "work_status",
    },
    {
      title: "CNIC",
      dataIndex: "cnic",
      key: "cnic",
    },
    {
      title: "Action",
      render: (record) => {return (<Dropdown overlay={() =>actions( record.id, record.status, record.cnic, record.fullName,
      record.batch.id, record.zone._id, record.is_approved, record.profileImage, record.display_id, record.fleet_id)}>
        <a onClick={(e) => e.preventDefault(setRiderId(record.id), setRiderName(record.fullName), setRiderBatchId(record.batch.id), setRiderZoneId(record.zone._id))}>
          <Button disabled={MBtnLoading}><MoreOutlined /></Button>
        </a>
      </Dropdown>)},
      onCell: (record, rowIndex) => {return {onClick: (e) => {e.stopPropagation()}}},
    },
  ];

  const onFinish = async (values) => {
    values.start_date = moment().add(5, "hours").toISOString();
    values.end_date = moment()
      .add(5 + values.duration / 60, "hours")
      .toISOString();
    if (values.duration == "customize") {
      values.start_date = moment(values.startDate)
        .add(5, "hours")
        .toISOString();
      values.end_date = moment(values.endtDate).add(5, "hours").toISOString();
    }
    if (values.duration == "until_shift_ends") {
      try {
        await props.riderActions
          .RiderOngoingShiftAction(values.riderId)
          .then((res) => {
            if (res) {
              if (res["status"]) {
                if (res["data"] == "") {
                  swalNotification(
                    "Rider Break",
                    "No ongoing shift exist",
                    "error"
                  );
                  return null;
                } else {
                  values.start_date = moment(values.startDate)
                    .add(5, "hours")
                    .toISOString();
                  values.end_date = moment(
                    res["data"][0].shiftId.endTime * 1000
                  ).format("YYYY-MM-DDThh:mm:ss.mmmZ");
                }
              }
            }
          });
      } catch (error) {
        validationErrors(error);
      }
    }
    try {
      await props.riderActions.postRiderBrakeAction(values).then((res) => {
        if (res) {
          if (res["status"]) {
            setRiderData(res["data"]);
            swalNotification("Rider Break", res["message"], "success");
          }
        }
      });
    } catch (error) {
      validationErrors(error);
    } finally {
      setAssignBreakModal(false);
      postListsrefresh();
    }
  };

  const [showModalAssignRiderZones, setshowModalAssignRiderZones] =
    useState(false);
  const showAssignRiderZonesModal = () => {
    setshowModalAssignRiderZones(true);
  };

  const filtersWithPagination = async (data) => {
    try {
      setLoading(true);
      await props.riderActions
        .getRidersFiltersPaginationAction(data)
        .then((res) => {});
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const [page, setPage] = useState(1);

  const pageChange = (page, pageSize) => {
    globalSearch(search, status, "", "", filterZone, page, pageSize);
  };

  const globalSearch = (
    search,
    status,
    fleet_id,
    display_id,
    zone,
    // start_date,
    // end_date,
    currentPage,
    currentPageSize
  ) => {
    const data = {
      keyword: search,
      fleet_id: fleet_id != "" ? fleet_id : "",
      // zone: filter == "zone" ? zone : "",
      status: status != "" ? status : "",
      id: display_id != "" ? display_id : "",
      zone:  zone? String(zone) : "",

      // zone: filter == "display_id" ? "" : zone != "" ? zone : "",
      // status: filter == "display_id" ? "" : status != "" ? status : "",
      // startDate:
      //   start_date == "" || start_date === null
      //     ? ""
      //     : moment(start_date).add(5, "hours").toISOString(),
      // endDate:
      //   end_date == "" || end_date === null
      //     ? ""
      //     : moment(end_date).add(5, "hours").toISOString(),
      page: currentPage,
      // limit: currentPageSize,
      limit: !currentPageSize ? 100 : currentPageSize,
    };

    filtersWithPagination(data);

    return postData;
  };

  return (
    <div className="page-content">
      <ModalAssignRiderZones
        visible={showModalAssignRiderZones}
        setvisible={setshowModalAssignRiderZones}
        postListsrefresh={postListsrefresh}
      />
      <RiderEditModal
        riderEditOpenModal={riderEditOpenModal}
        setRiderEditOpenModal={setRiderEditOpenModal}
        riderData={riderData}
        RiderId={RiderId}
        postDataZone={postDataZone}
        riderZoneChange={riderZoneChange}
      />
      {assignBatchModal && (
        <BatchModal
          RiderName={RiderName}
          riderBatchId={riderBatchId}
          assignBatchModal={assignBatchModal}
          handleOk={BatchModalHandleOk}
          handleCancel={handleCancel}
          postDatabatch={postDatabatch}
          riderBatchChange={riderBatchChange}
          value={riderBatchId}
          showBatchSubmitLoder={showBatchSubmitLoder}
        />
      )}
      {assignZoneModal && (
        <ZoneModal
          RiderName={RiderName}
          riderZoneId={riderZoneId}
          assignZoneModal={assignZoneModal}
          handleOk={handleZoneOk}
          handleCancel={handleZoneModalCancel}
          postDataZone={postDataZone}
          riderZoneChange={riderZoneChange}
          value={riderZoneId}
        />
      )}
      {assignBreakModal && (
        <BreakModal
          RiderName={RiderName}
          RiderImage={RiderImage}
          RiderDisplayId={RiderDisplayId}
          RiderTookanId={RiderTookanId}
          assignBreakModal={assignBreakModal}
          handleCancel={handleBreakModalCancel}
          RiderId={RiderId}
          onFinish={onFinish}
        />
      )}
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch">
            <Badge
              count={props.riderPagination.totalRidersCount? "Total Riders: " + props.riderPagination.totalRidersCount: "Total Riders: " + 0}
              style={{backgroundColor: "transparent",color: "#282828",boxShadow: "0 0 0 1px #282828",}}
            />
            <Badge
              count={props.riderPagination.totalActiveRiders? "Active Riders: " + props.riderPagination.totalActiveRiders: "Active Riders: " + 0}
              style={{backgroundColor: "#52c41a",}}
            />
            {/* <Badge
              count={ghostRiders ? "Ghost Riders: " + 0 : "Ghost Riders: " + 0}
            /> */}
            <Select
              disabled={MBtnLoading || loading}
              value={filter}
              onChange={setFiltervalue}
              className="dropmenu dropdown-menu"
              style={{width: 120,}}
            >
              <Option value="all">All</Option>
              <Option value="display_id">Rider ID</Option>
              <Option value="fleet_id">Tookan Rider ID</Option>
            </Select>
            <Select
              disabled={MBtnLoading || loading}
              value={status}
              onChange={setStatusValue}
              className="dropmenu dropdown-menu"
              style={{width: 120,}}
            >
              <Option value="available">Active</Option>
              <Option value="inactive">Inactive</Option>
              <Option value="pending">Pending</Option>
              <Option value="blocked">Blocked</Option>
            </Select>

            {filter === "display_id" ? (
              <Search
                placeholder=""
                value={displayId}
                onChange={(e) => setDisplayId(e.target.value)}
                onSearch={setDisplayIdValue}
                disabled={errMsg != null || MBtnLoading || loading}
              />
            ) : (
              ""
            )}

            {filter === "fleet_id" ? (
              <Search
                placeholder=""
                value={tookanRiderId}
                onChange={(e) => setTookanRiderId(e.target.value)}
                onSearch={setTookanRiderIdValue}
                disabled={errMsg != null || MBtnLoading || loading}
              />
            ) : (
              ""
            )}

            {filter === "all" ? (
              <Search
                placeholder=""
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onSearch={setSearchValue}
                disabled={errMsg != null || MBtnLoading || loading}
              />
            ) : (
              ""
            )}
            <Select
              showSearch
              mode="multiple"
              allowClear
              filterOption={(input, option) =>  
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
                || option.props.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // defaultValue={searchStoreIds.storeIds}
              // value={searchStoreIds.storeIds}
              placeholder="Please select Zone"
              onChange={handleChangeZone}
              style={{ minWidth: 300,}}
            >
              {postDataZoneSelect}
            </Select>

            {/* <Button
              disabled={MBtnLoading || loading}
              onClick={showAssignRiderZonesModal}
            >
              Visible Zone
            </Button> */}
            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_TOOKAN_SYNC) &&
              <Tooltip title="Sync tookan data">
                <Button
                  icon={<ReloadOutlined />}
                  loading={MBtnLoading}
                  disabled={loading}
                  onClick={() => importTookanData(true)}
                />
              </Tooltip>
            }
            
            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_RIDERS) &&
              <Button
                onClick={() => navigate("/rider/add")}
                disabled={MBtnLoading}
              >
                Create Rider
              </Button>
            }
            <Dropdown overlay={
                <Menu
                  items={[
                    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) &&
                    ({
                      key: "1",
                      label: <a onClick={() => navigate("/rider/suspendriderbulk")}>Suspend Rider csv upload</a>
                    }),
                    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) &&
                    ({
                      key: "2",
                      label: <a onClick={() => navigate("/rider/inactiveriderbulk")}>Active & Inactive Rider csv upload</a>
                    }),
                    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) &&
                    ({
                      key: "3",
                      label: <a onClick={() => navigate("/rider/blockriderbulk")}>Block Rider csv upload</a>
                    })
                  ]}
                />
              }
            >
              <Button disabled={MBtnLoading}><MoreOutlined /></Button>
            </Dropdown>
        </div>
      </div>
      <div className="p-content">
        {loading ? (
          <Pageloader />
        ) : (
          <Table
            className="tablehover"
            dataSource={postData}
            columns={riderColumns}
            pagination={{
              current: currentPage,
              pageSize: currentPageSize,
              pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
              showSizeChanger: true,
              total: totalPages, // total count returned from backend
              onChange: (page, pageSize) => {
                pageChange(page, pageSize);
              },
            }}
            onRow={(r, i) => ({
              onDoubleClick: (e) => window.open(`/rider/${r.id}`),
            })}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    riderData: state.RiderReducer.riderData,
    riderPagination: state.RiderReducer.riderPagination,
    riderDetailData: state.RiderReducer.riderDetailData,
    batchData: state.BatchReducer.batchData,
    zoneData: state.ZoneReducer.zoneData,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    riderActions: bindActionCreators(riderActions, dispatch),
    batchActions: bindActionCreators(batchActions, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rider);
